import Vue from 'vue';
import materialConstants from '../constants/material-constants';
import orderConstants from '../constants/order-constants';
import orderService from './order-service';
import Http from '../libs/http';

export default {

  /**
   * 根据申请人编号获取订单中的申请人
   * @param {Object} order 订单
   * @param {Number} applicantId 申请人编号
   * @return {Object}
   */
  getApplicantInOrderByApplicantId(order, applicantId) {
    let applicant = {};
    const orderCopy = JSON.parse(JSON.stringify(order)); // 暴力将响应式对象变为非响应式对象

    if (orderCopy.applicant) {
      const targetApplicants = orderCopy.applicant.filter(ap => ap.order_applicant_id === applicantId);

      if (targetApplicants && targetApplicants.length > 0) {
        applicant = targetApplicants[0];
      }
    }

    return applicant;
  },

  /**
   * 订单状态是不是在支付前可以处理电子资料的状态
   */
  isOrderStatusBeforePay(orderStatus) {
    // 此处处理的是订单还未支付之前来到重新上传页面，需要可以修改和上传资料
    const orderStatusBeforeOrderPay = [
      orderConstants.STATUS.waittingToUploadMaterial_1,
      orderConstants.STATUS.waittingToWriteApplicantion_2,
      orderConstants.STATUS.waittingToSelectGoToEmbassyTime_10,
      orderConstants.STATUS.waittingToPay_3,
    ];

    return orderStatusBeforeOrderPay.indexOf(orderStatus) > -1;
  },

  /**
   * 获取申请人的所有这种资料
   * @param {Object} applicantMaterial 申请人的资料
   * @param {Number} materialType 资料类型（可选）
   * @return {Array}
   */
  getApplicantAllThisTypeMaterial(applicantMaterial, materialType) {
    let materials = applicantMaterial.material_required.concat(applicantMaterial.material_optional);

    if (typeof materialType !== 'undefined') {
      materials = materials.filter(material => material.attr === materialType);
    }

    return materials;
  },

  /**
   * 创建一个空的电子资料的upload项
   * @param {Object} props 属性，可以直接进行覆盖(可选)
   * @return {Object}
   */
  createEmptyElecUploadItem(props) {
    let uploadItem = {
      elec_status: '',
      pos: 1,
      url: '',
      special_code: 0,
      memo: '',
      temp: true,
    };

    if (typeof props !== 'undefined' && props instanceof Object) {
      uploadItem = { ...uploadItem, ...props };
    }

    return uploadItem;
  },

  /**
   * 初始化申请人的电子资料
   * @param {Object} applicant 申请人
   */
  initApplicantElecMaterialDataForUpload(applicant) {
    if (applicant.material) {
      // 这里使用这种蛋疼的写法是为了直接修改目标对象，而不是赋值回去
      [applicant.material.material_required, applicant.material.material_optional].forEach((materialTypeArr) => {
        materialTypeArr.forEach((material) => {
          // 只处理电子资料
          if (material.attr !== materialConstants.TYPE.elec_0) return;

          // 如果upload数组没有或者upload为空数组需要添加默认的一个项
          material.upload = material.upload && material.upload.length ? material.upload : [this.createEmptyElecUploadItem()];

          // 如果是身份证，但是upload只有一项的时候，***我记得是'没有身份证'的操作的时候会出现这种情况***
          if (material.pattern === materialConstants.PATTERN.idCardOCR_1 && material.upload.length < 2) {
            // 如果只有一个的时候，如果pos为1，则表示为身份证人像面，则需要加一个背面，如果有背面，则在前面加一个正面
            if (material.upload[0].pos === materialConstants.ID_CARD.front) {
              material.upload.push(this.createEmptyElecUploadItem({ pos: materialConstants.ID_CARD.back }));
            } else {
              material.upload.splice(0, 0, this.createEmptyElecUploadItem());
            }
          }

          // 普通多页资料如果只有一项（上面的代码保证了至少有一项），且第一项已经有图片了（url有值）,则再往里面加一项
          if (material.pattern === materialConstants.PATTERN.defaul_0 &&
              material.style === materialConstants.STYLE.multiPage_1 &&
              material.upload[material.upload.length - 1].url) {
            material.upload.push(this.createEmptyElecUploadItem({ pos: material.upload[material.upload.length - 1].pos + 1 }));
          }
        });
      });
    }
  },

  /**
   * 初始化可选资料的特殊状态
   * @param {Object} applicant 申请人
   */
  initApplicantOptinalMaterialSpecial(applicant) {
    // 可选资料才有资料补充
    if (applicant.material.material_optional && applicant.material.material_optional.length > 0) {
      // 拿到当前属于的资料类别
      applicant.material.material_optional.forEach((material, index) => {
        if (!material.upload) {
          material.upload = [];
        }

        // 需补充资料的肯定只有一个
        if (material.upload.length === 1) {
          material.refuseUpload = {
            checked: material.upload[0].special_code === materialConstants.SPECIAL_CODE.temporarilyNotUpload_6,
          };
        }
        applicant.material.material_optional[index] = material;
      });
    }
  },

  /**
   * 初始化特殊属性的值
   * @param {Object} applicant 申请人
   */
  initSpecialAttrValue(applicant) {
    // 婚姻状态（字符串才能选中）
    applicant.marital_status = applicant.marital_status.toString();

    if (applicant.marital_status === materialConstants.MARITAL_STATUS.unknown_0.toString()) {
      applicant.marital_status = materialConstants.MARITAL_STATUS.married_2.toString();
    }

    // 没有身份证下面的特殊状态
    Vue.set(applicant, 'id_card_special_status', orderService.getApplicantIdCarSpecialStatus(applicant).toString());

    // 是不是没有身份证
    Vue.set(applicant, 'is_id_card_special', applicant.id_card_special_status > 0);
  },

  /**
   * 清除申请人电子资料中空的upload项
   * @param {Object} applicant 申请人
   */
  removeApplicantElecMaterialEmptyUploadItem(applicant) {
    if (applicant.order_applicant_id) {
      [applicant.material.material_required, applicant.material.material_optional].forEach((materialTypeArr) => {
        materialTypeArr.forEach((material) => {
          material.upload && material.upload.forEach((item, index) => {
            // 没有地址代表没有上传，且special_code为0
            if (!item.url && !item.special_code) {
              material.upload.splice(index, 1);
            }
          });
        });
      });
    }
  },

  /**
   * 照片单独处理接口
   */
  applicantIdPhotoHandle(data) {
    return Http.post('/applicant_id_photo_handle', data);
  },
};



// WEBPACK FOOTER //
// ./src/services/upload-service.js